import { render } from "./shutdownRecord.vue?vue&type=template&id=067468eb&scoped=true"
import script from "./shutdownRecord.vue?vue&type=script&lang=js"
export * from "./shutdownRecord.vue?vue&type=script&lang=js"

import "./shutdownRecord.vue?vue&type=style&index=0&id=067468eb&scoped=true&lang=css"
import "./shutdownRecord.vue?vue&type=style&index=1&id=067468eb&lang=css"
script.render = render
script.__scopeId = "data-v-067468eb"

export default script